export default __webpack_public_path__ + "static/media/bg-pc.7ae00d29.png";